module.exports = __webpack_public_path__ + "static/media/m7cr148.3b7c035f.png";